const al = {
  //main screen
  promo_title: 'Ticket Land',
  promo_label_days: {
    one: 'ditë',
    other: 'ditë',
  },
  promo_label_hours: 'orë',
  promo_label_minutes: 'min',
  promo_prizes_section: 'Aktivizo dhuratën e sotme si dhe përfito bileta për shorteun e madh',
  promo_view_prizes_button: 'Shiko dhuratat',
  promo_daily_rewards_section: 'Kalendari i dhuratave',
  promo_daily_gift_day: 'dita ',
  promo_tickets_claimed_label: 'bileta të\nmbledhura',
  promo_tenure_bonus_label: 'për vitet me ne',
  promo_tenure_one_year_bonus_label: 'Bëhu Vodafone\ndhe përfito',
  promo_tickets_total_label: 'bileta\nnë total',
  promo_nr_of_years: "x%1$s bonus",
  promo_one_year_bonus: "x100",
  promo_modal_header_info: 'Informacione',
  promo_button_upgrade_gift: 'Po, vazhdo për %1$s %2$s',
  promo_button_continue_free: 'Jo, aktivizo dhuratën falas',
  promo_button_error_general: 'Dicka nuk funksionoi',
  promo_button_go_back: 'Kthehu',
  promo_no_credit: 'Ti nuk ke kredit të mjaftueshëm',
  promo_button_yes_continue: 'Po, vazhdo',
  promo_button_close: 'Mbyll',
  promo_processing_button: 'Duke procesuar...',

  //prizes screen
  promo_grand_total_title: 'Totali i biletave',
  promo_draw_date_label: 'Dita e shorteut',
  promo_tickets_collected_label: 'Totali i biletave të shorteut',
  promo_draw_prizes_label: 'Dhuratat e shorteut',
  promo_catalogue_list_label: 'Katalogu',
  promo_total_gifts_label: 'Dhurata në shorte',
  promo_total_prizes_description: '*Numri total i blietave të mbledhura nga të gjithë, do i kthehet rinisë së Vodafone si GB në Janar.',
  promo_prizes_available_label: 'Në total',
  promo_more_info_url: 'https://api-web-ci-vfal.vodafone.com/file/2020promo/MoreInfoPromo_AL.html',

  promo_info_card_title: 'Përfitimet e besnikërisë',
  promo_info_card_desc: 'Shumëzuesi i biletave totale',

  promo_open_now: 'Zbulo tani',
}

export default al
